import { render, staticRenderFns } from "./CheckboxModal.vue?vue&type=template&id=1be904e1&"
import script from "./CheckboxModal.vue?vue&type=script&lang=ts&"
export * from "./CheckboxModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports